import React, { useState, useEffect, useCallback } from 'react';
import './App.css';

// Synergys Brand Icons (from identidade_visual)
const SynergysIcon = ({ variant = "01", size = 40, className = "" }) => (
  <img 
    src={`/assets/icons/favicon-${variant}.png`}
    alt="Synergys"
    style={{ width: size, height: size, objectFit: 'contain' }}
    className={className}
  />
);

const SectorIcon = ({ type, size = 40 }) => {
  const iconMap = {
    sst: '/assets/icons/sst.png',
    qualidade: '/assets/icons/qualidade.png',
    'meio-ambiente': '/assets/icons/meio-ambiente.png'
  };
  return (
    <img 
      src={iconMap[type]}
      alt={type}
      style={{ width: size, height: size, objectFit: 'contain' }}
    />
  );
};

// Minimal SVG for navigation only
const NavIcons = {
  ChevronLeft: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="15 18 9 12 15 6"/>
    </svg>
  ),
  ChevronRight: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="9 18 15 12 9 6"/>
    </svg>
  )
};

// Slide Components
function SlideCover() {
  return (
    <div className="slide cover-slide">
      <div className="cover-content">
        <img 
          src="/assets/logos/Synergys - Logotipo 01.png" 
          alt="Synergys" 
          className="cover-logo"
        />
        <h1 className="cover-title">Pesquisas Psicossociais 100% Anônimas</h1>
        <p className="cover-subtitle">
          Plataforma com arquitetura de privacidade radical — impossível rastrear respostas
        </p>
        <div className="cover-cards">
          <div className="cover-card">
            <div className="cover-card-label">Plataforma</div>
            <div className="cover-card-value">SYNERGYS SIERE</div>
          </div>
          <div className="cover-card">
            <div className="cover-card-label">Módulo</div>
            <div className="cover-card-value">Pesquisas QSMS</div>
          </div>
          <div className="cover-card">
            <div className="cover-card-label">Garantia</div>
            <div className="cover-card-value">Anonimato Total</div>
          </div>
          <div className="cover-card">
            <div className="cover-card-label">Data</div>
            <div className="cover-card-value">Fevereiro 2026</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function SlideAnonimatoGarantido() {
  return (
    <div className="slide content-slide">
      <div className="slide-header">
        <div className="slide-number"><SynergysIcon variant="01" size={28} /></div>
        <h2 className="slide-title">Por Que Sua Resposta é 100% Anônima?</h2>
        <p className="slide-description">
          Entenda a arquitetura técnica que IMPOSSIBILITA qualquer identificação
        </p>
      </div>
      
      <div className="trust-banner">
        <SynergysIcon variant="02" size={48} />
        <div className="trust-text">
          <strong>Compromisso Synergys:</strong> Nem nós, nem sua empresa, nem ninguém pode descobrir quem respondeu o quê. É tecnicamente impossível.
        </div>
      </div>
      
      <div className="guarantee-grid">
        <div className="guarantee-section negative">
          <div className="guarantee-header">
            <SynergysIcon variant="03" size={32} />
            <span>O que NUNCA é coletado ou armazenado</span>
          </div>
          <ul className="guarantee-list negative">
            <li>Seu endereço IP (não registramos)</li>
            <li>Seu navegador ou dispositivo</li>
            <li>Cookies de identificação</li>
            <li>Horário exato que você respondeu</li>
            <li>Sua localização geográfica</li>
            <li>Qualquer vínculo entre token e resposta</li>
            <li>Metadados de sessão ou conexão</li>
            <li>Nome, email ou qualquer dado pessoal</li>
          </ul>
        </div>
        
        <div className="guarantee-section positive">
          <div className="guarantee-header">
            <SynergysIcon variant="01" size={32} />
            <span>O que SIM é armazenado (sem identificação)</span>
          </div>
          <ul className="guarantee-list positive">
            <li>Apenas as respostas da pesquisa</li>
            <li>Hash criptográfico do token (impede reutilização)</li>
            <li>Data da resposta (apenas o dia, não a hora)</li>
            <li>ID da empresa (para separar clientes)</li>
            <li>ID da pesquisa vinculada</li>
            <li>Estatísticas agregadas (totais, médias)</li>
          </ul>
          <div className="guarantee-note">
            As respostas são órfãs — não existe nenhuma chave que as conecte a você.
          </div>
        </div>
      </div>
    </div>
  );
}

function SlideComoFunciona() {
  return (
    <div className="slide content-slide">
      <div className="slide-header">
        <div className="slide-number"><SynergysIcon variant="02" size={28} /></div>
        <h2 className="slide-title">Como Funciona o Anonimato?</h2>
        <p className="slide-description">
          O sistema foi projetado para que seja IMPOSSÍVEL identificar quem respondeu
        </p>
      </div>
      
      <div className="how-it-works">
        <div className="step-card">
          <div className="step-header">
            <span className="step-num">1</span>
            <SynergysIcon variant="01" size={36} />
          </div>
          <h3>Você Recebe um Token Único</h3>
          <p>
            Cada colaborador recebe um código aleatório (token). 
            <strong> A empresa NÃO sabe qual token é de quem.</strong> 
            Os tokens são distribuídos de forma embaralhada.
          </p>
        </div>
        
        <div className="step-card">
          <div className="step-header">
            <span className="step-num">2</span>
            <SynergysIcon variant="02" size={36} />
          </div>
          <h3>Você Responde Sem Identificação</h3>
          <p>
            Ao acessar a pesquisa, <strong>não pedimos login, email, nome ou qualquer dado pessoal.</strong> 
            Seu IP e navegador são ignorados pelo sistema. Apenas o token é verificado.
          </p>
        </div>
        
        <div className="step-card">
          <div className="step-header">
            <span className="step-num">3</span>
            <SynergysIcon variant="03" size={36} />
          </div>
          <h3>Token é Destruído Após Uso</h3>
          <p>
            Após enviar sua resposta, o token é marcado como "usado" e <strong>desvinculado permanentemente</strong>. 
            A resposta fica órfã — sem conexão com o token original.
          </p>
        </div>
        
        <div className="step-card highlight">
          <div className="step-header">
            <span className="step-num">✓</span>
            <SynergysIcon variant="01" size={36} />
          </div>
          <h3>Resultado: Impossível Rastrear</h3>
          <p>
            <strong>Nem a empresa, nem a Synergys, nem hackers, nem tribunais</strong> podem descobrir quem deu qual resposta. 
            A informação simplesmente não existe no sistema.
          </p>
        </div>
      </div>
    </div>
  );
}

function SlideArquitetura() {
  return (
    <div className="slide architecture-slide">
      <div className="slide-header">
        <div className="slide-number"><SynergysIcon variant="01" size={28} /></div>
        <h2 className="slide-title">Arquitetura de Privacidade Radical</h2>
        <p className="slide-description">
          Dois sistemas completamente separados — anônimo e administrativo nunca se cruzam
        </p>
      </div>
      
      <div className="flow-container">
        <div className="flow-section anonymous">
          <div className="flow-title">
            <SynergysIcon variant="02" size={28} />
            Sistema Anônimo (Respondente)
          </div>
          <div className="flow-steps">
            <div className="flow-step">
              <div className="step-number">1</div>
              <div className="step-text">Colaborador acessa link com token único</div>
            </div>
            <div className="flow-arrow">↓</div>
            <div className="flow-step">
              <div className="step-number">2</div>
              <div className="step-text">Sistema valida token <strong>SEM registrar IP</strong></div>
            </div>
            <div className="flow-arrow">↓</div>
            <div className="flow-step">
              <div className="step-number">3</div>
              <div className="step-text">Resposta salva <strong>SEM identificador</strong></div>
            </div>
            <div className="flow-arrow">↓</div>
            <div className="flow-step">
              <div className="step-number">4</div>
              <div className="step-text">Token invalidado <strong>SEM vincular à resposta</strong></div>
            </div>
          </div>
          <div className="flow-badge">Zero logs de identificação</div>
        </div>
        
        <div className="flow-section admin">
          <div className="flow-title">
            <SynergysIcon variant="03" size={28} />
            Sistema Administrativo (RH/Gestão)
          </div>
          <div className="flow-steps">
            <div className="flow-step">
              <div className="step-number">1</div>
              <div className="step-text">Admin cria pesquisa no dashboard</div>
            </div>
            <div className="flow-arrow">↓</div>
            <div className="flow-step">
              <div className="step-number">2</div>
              <div className="step-text">Gera lote de tokens embaralhados</div>
            </div>
            <div className="flow-arrow">↓</div>
            <div className="flow-step">
              <div className="step-number">3</div>
              <div className="step-text">Visualiza apenas relatórios agregados</div>
            </div>
            <div className="flow-arrow">↓</div>
            <div className="flow-step">
              <div className="step-number">4</div>
              <div className="step-text">Exporta estatísticas (nunca respostas individuais)</div>
            </div>
          </div>
          <div className="flow-badge">Apenas dados agregados</div>
        </div>
      </div>
    </div>
  );
}

function SlideSegurancaTecnica() {
  return (
    <div className="slide content-slide">
      <div className="slide-header">
        <div className="slide-number"><SynergysIcon variant="03" size={28} /></div>
        <h2 className="slide-title">Segurança Técnica Avançada</h2>
        <p className="slide-description">
          Múltiplas camadas de proteção para garantir privacidade absoluta
        </p>
      </div>
      
      <div className="cards-grid">
        <div className="card">
          <div className="card-icon"><SynergysIcon variant="01" size={40} /></div>
          <h3 className="card-title">Criptografia Ponta-a-Ponta</h3>
          <p className="card-text">
            TLS 1.3 em todas as conexões. Seus dados viajam criptografados 
            do seu navegador até nossos servidores. Impossível interceptar.
          </p>
        </div>
        
        <div className="card">
          <div className="card-icon"><SynergysIcon variant="02" size={40} /></div>
          <h3 className="card-title">Sem Logs de Identificação</h3>
          <p className="card-text">
            O sistema anônimo não registra IP, user-agent, cookies ou qualquer 
            metadado que possa identificar você. Configuração deliberada.
          </p>
        </div>
        
        <div className="card">
          <div className="card-icon"><SynergysIcon variant="03" size={40} /></div>
          <h3 className="card-title">Tokens Criptográficos</h3>
          <p className="card-text">
            Cada token é um UUID v4 com hash SHA-256. Matematicamente impossível 
            prever, duplicar ou reverter para descobrir a origem.
          </p>
        </div>
        
        <div className="card">
          <div className="card-icon"><SynergysIcon variant="01" size={40} /></div>
          <h3 className="card-title">Separação de Dados</h3>
          <p className="card-text">
            Tokens e respostas ficam em tabelas separadas, sem chave de ligação. 
            Mesmo com acesso ao banco de dados, é impossível correlacionar.
          </p>
        </div>
        
        <div className="card">
          <div className="card-icon"><SynergysIcon variant="02" size={40} /></div>
          <h3 className="card-title">Infraestrutura Edge</h3>
          <p className="card-text">
            Servidores distribuídos globalmente via Cloudflare. 
            Proteção contra DDoS, WAF ativo, certificados automáticos.
          </p>
        </div>
        
        <div className="card">
          <div className="card-icon"><SynergysIcon variant="03" size={40} /></div>
          <h3 className="card-title">Auditoria Independente</h3>
          <p className="card-text">
            Código auditado para garantir que promessas de privacidade 
            são cumpridas tecnicamente. Transparência total.
          </p>
        </div>
      </div>
    </div>
  );
}

function SlidePerguntasFrequentes() {
  return (
    <div className="slide content-slide">
      <div className="slide-header">
        <div className="slide-number"><SynergysIcon variant="01" size={28} /></div>
        <h2 className="slide-title">Perguntas Frequentes sobre Anonimato</h2>
        <p className="slide-description">
          Dúvidas comuns dos colaboradores — respondidas com transparência
        </p>
      </div>
      
      <div className="faq-grid">
        <div className="faq-item">
          <div className="faq-q">
            <SynergysIcon variant="02" size={24} />
            <span>Minha empresa pode ver quem respondeu?</span>
          </div>
          <div className="faq-a">
            <strong>Não.</strong> A empresa vê apenas estatísticas agregadas (ex: "70% dos colaboradores 
            concordam que..."). Nunca respostas individuais vinculadas a pessoas.
          </div>
        </div>
        
        <div className="faq-item">
          <div className="faq-q">
            <SynergysIcon variant="02" size={24} />
            <span>E se minha empresa pedir os dados à Synergys?</span>
          </div>
          <div className="faq-a">
            <strong>Não temos como fornecer.</strong> A informação de "quem respondeu o quê" simplesmente 
            não existe em nosso sistema. Não é uma política — é uma impossibilidade técnica.
          </div>
        </div>
        
        <div className="faq-item">
          <div className="faq-q">
            <SynergysIcon variant="02" size={24} />
            <span>E se hackers invadirem o sistema?</span>
          </div>
          <div className="faq-a">
            <strong>Ainda assim não descobririam.</strong> Mesmo com acesso total ao banco de dados, 
            não há como vincular respostas a pessoas. Os dados não existem para serem roubados.
          </div>
        </div>
        
        <div className="faq-item">
          <div className="faq-q">
            <SynergysIcon variant="02" size={24} />
            <span>Meu IP ou computador é registrado?</span>
          </div>
          <div className="faq-a">
            <strong>Não.</strong> Deliberadamente configuramos o sistema para não registrar IP, 
            user-agent, cookies ou qualquer identificador de dispositivo.
          </div>
        </div>
        
        <div className="faq-item">
          <div className="faq-q">
            <SynergysIcon variant="02" size={24} />
            <span>Como sei que a empresa não distribuiu tokens rastreados?</span>
          </div>
          <div className="faq-a">
            <strong>Os tokens são gerados pelo sistema Synergys</strong>, não pela empresa. 
            São distribuídos embaralhados. A empresa não tem acesso ao mapeamento token-pessoa.
          </div>
        </div>
        
        <div className="faq-item">
          <div className="faq-q">
            <SynergysIcon variant="02" size={24} />
            <span>Posso confiar mesmo?</span>
          </div>
          <div className="faq-a">
            <strong>Sim.</strong> Nossa arquitetura é auditável e baseada no princípio de "privacidade 
            por design". Não confiamos em promessas — confiamos em impossibilidades técnicas.
          </div>
        </div>
      </div>
    </div>
  );
}

function SlideTiposPesquisa() {
  return (
    <div className="slide content-slide">
      <div className="slide-header">
        <div className="slide-number"><SynergysIcon variant="02" size={28} /></div>
        <h2 className="slide-title">Tipos de Pesquisas</h2>
        <p className="slide-description">
          Modelos pré-configurados para diferentes necessidades — todas 100% anônimas
        </p>
      </div>
      
      <div className="cards-grid">
        <div className="card">
          <div className="card-icon">
            <SectorIcon type="sst" size={48} />
          </div>
          <h3 className="card-title">Riscos Psicossociais</h3>
          <p className="card-text">
            Avaliação de estresse, sobrecarga, assédio moral, conflitos interpessoais 
            e outros riscos à saúde mental. Baseado em metodologias científicas validadas. 
            <strong> Respostas totalmente anônimas.</strong>
          </p>
        </div>
        
        <div className="card">
          <div className="card-icon">
            <SectorIcon type="qualidade" size={48} />
          </div>
          <h3 className="card-title">Clima Organizacional</h3>
          <p className="card-text">
            Satisfação com liderança, comunicação interna, oportunidades de crescimento, 
            equilíbrio vida-trabalho e engajamento. 
            <strong> Sem medo de retaliação.</strong>
          </p>
        </div>
        
        <div className="card">
          <div className="card-icon">
            <SectorIcon type="meio-ambiente" size={48} />
          </div>
          <h3 className="card-title">Satisfação e NPS Interno</h3>
          <p className="card-text">
            Net Promoter Score, CSAT de processos, avaliação de benefícios, 
            feedback sobre políticas da empresa. 
            <strong> Opiniões honestas garantidas.</strong>
          </p>
        </div>
      </div>
    </div>
  );
}

function SlideConformidade() {
  return (
    <div className="slide content-slide">
      <div className="slide-header">
        <div className="slide-number"><SynergysIcon variant="03" size={28} /></div>
        <h2 className="slide-title">Conformidade Legal (LGPD)</h2>
        <p className="slide-description">
          Atendimento completo à Lei Geral de Proteção de Dados Pessoais
        </p>
      </div>
      
      <div className="cards-grid">
        <div className="card">
          <div className="card-icon"><SynergysIcon variant="01" size={40} /></div>
          <h3 className="card-title">Base Legal Clara</h3>
          <p className="card-text">
            Consentimento informado opcional (Art. 7°, I) ou Interesse legítimo 
            para pesquisas de SST (Art. 7°, IX). Termo apresentado antes da pesquisa.
          </p>
        </div>
        
        <div className="card">
          <div className="card-icon"><SynergysIcon variant="02" size={40} /></div>
          <h3 className="card-title">Minimização Extrema</h3>
          <p className="card-text">
            Não coletamos dados pessoais — ponto. Sem nome, email, IP, dispositivo. 
            Apenas as respostas da pesquisa, sem identificador.
          </p>
        </div>
        
        <div className="card">
          <div className="card-icon"><SynergysIcon variant="03" size={40} /></div>
          <h3 className="card-title">Direito ao Esquecimento</h3>
          <p className="card-text">
            Como não há dados pessoais vinculados, não há o que "esquecer". 
            O anonimato resolve o problema antes dele existir.
          </p>
        </div>
        
        <div className="card">
          <div className="card-icon"><SynergysIcon variant="01" size={40} /></div>
          <h3 className="card-title">Retenção Configurável</h3>
          <p className="card-text">
            Política de retenção definida por cada empresa. 
            Exclusão automática após período. Dados agregados mantidos para histórico.
          </p>
        </div>
      </div>
    </div>
  );
}

function SlideDashboard() {
  return (
    <div className="slide content-slide">
      <div className="slide-header">
        <div className="slide-number"><SynergysIcon variant="01" size={28} /></div>
        <h2 className="slide-title">Painel Administrativo</h2>
        <p className="slide-description">
          Interface completa para gestão — sem acesso a dados individuais
        </p>
      </div>
      
      <div className="cards-grid">
        <div className="card">
          <div className="card-icon"><SynergysIcon variant="01" size={40} /></div>
          <h3 className="card-title">Gestão de Pesquisas</h3>
          <p className="card-text">
            Criar, editar e publicar pesquisas. Templates pré-configurados. 
            Agendamento automático. Configuração de anonimato.
          </p>
        </div>
        
        <div className="card">
          <div className="card-icon"><SynergysIcon variant="02" size={40} /></div>
          <h3 className="card-title">Geração de Tokens</h3>
          <p className="card-text">
            Gerar lotes de tokens embaralhados. Exportar para CSV ou QR codes. 
            Monitorar taxa de resposta (sem saber quem respondeu).
          </p>
        </div>
        
        <div className="card">
          <div className="card-icon"><SynergysIcon variant="03" size={40} /></div>
          <h3 className="card-title">Relatórios Agregados</h3>
          <p className="card-text">
            Dashboards com estatísticas. Gráficos interativos. 
            Exportação PDF/Excel. <strong>Nunca respostas individuais.</strong>
          </p>
        </div>
        
        <div className="card">
          <div className="card-icon"><SynergysIcon variant="01" size={40} /></div>
          <h3 className="card-title">Multi-Empresa</h3>
          <p className="card-text">
            Isolamento completo entre clientes. Customização de marca. 
            Subdomínios dedicados. Gestão de usuários e permissões.
          </p>
        </div>
      </div>
    </div>
  );
}

function SlidePrecos() {
  return (
    <div className="slide content-slide">
      <div className="slide-header">
        <div className="slide-number"><SynergysIcon variant="02" size={28} /></div>
        <h2 className="slide-title">Planos e Preços</h2>
        <p className="slide-description">
          Soluções flexíveis — todos os planos incluem anonimato total
        </p>
      </div>
      
      <div className="pricing-grid">
        <div className="pricing-card">
          <h3 className="pricing-name">Starter</h3>
          <div className="pricing-price">R$ 497</div>
          <div className="pricing-period">por mês</div>
          <ul className="pricing-features">
            <li><SynergysIcon variant="01" size={18} /> Até 100 colaboradores</li>
            <li><SynergysIcon variant="01" size={18} /> 3 pesquisas ativas</li>
            <li><SynergysIcon variant="01" size={18} /> Relatórios agregados</li>
            <li><SynergysIcon variant="01" size={18} /> Suporte por email</li>
            <li><SynergysIcon variant="01" size={18} /> Anonimato total incluso</li>
          </ul>
          <button className="pricing-btn secondary">Contratar</button>
        </div>
        
        <div className="pricing-card featured">
          <h3 className="pricing-name">Professional</h3>
          <div className="pricing-price">R$ 1.497</div>
          <div className="pricing-period">por mês</div>
          <ul className="pricing-features">
            <li><SynergysIcon variant="01" size={18} /> Até 500 colaboradores</li>
            <li><SynergysIcon variant="01" size={18} /> Pesquisas ilimitadas</li>
            <li><SynergysIcon variant="01" size={18} /> Relatórios avançados</li>
            <li><SynergysIcon variant="01" size={18} /> Suporte prioritário</li>
            <li><SynergysIcon variant="01" size={18} /> API de integração</li>
            <li><SynergysIcon variant="01" size={18} /> Anonimato total incluso</li>
          </ul>
          <button className="pricing-btn primary">Contratar</button>
        </div>
        
        <div className="pricing-card">
          <h3 className="pricing-name">Enterprise</h3>
          <div className="pricing-price">Sob consulta</div>
          <div className="pricing-period">personalizado</div>
          <ul className="pricing-features">
            <li><SynergysIcon variant="01" size={18} /> Colaboradores ilimitados</li>
            <li><SynergysIcon variant="01" size={18} /> Multi-empresa</li>
            <li><SynergysIcon variant="01" size={18} /> SSO/SAML</li>
            <li><SynergysIcon variant="01" size={18} /> SLA dedicado</li>
            <li><SynergysIcon variant="01" size={18} /> Customização completa</li>
            <li><SynergysIcon variant="01" size={18} /> Anonimato total incluso</li>
          </ul>
          <button className="pricing-btn secondary">Falar com Vendas</button>
        </div>
      </div>
    </div>
  );
}

function SlideRoadmap() {
  return (
    <div className="slide content-slide">
      <div className="slide-header">
        <div className="slide-number"><SynergysIcon variant="03" size={28} /></div>
        <h2 className="slide-title">Roadmap 2026</h2>
        <p className="slide-description">
          Próximas funcionalidades — sempre mantendo privacidade como prioridade
        </p>
      </div>
      
      <div className="timeline">
        <div className="timeline-item">
          <div className="timeline-marker"><SynergysIcon variant="01" size={28} /></div>
          <div className="timeline-content">
            <div className="timeline-date">Q1 2026</div>
            <h4 className="timeline-title">App Mobile Offline</h4>
            <p className="timeline-text">
              Aplicativo para responder pesquisas sem internet. 
              Sincronização anônima quando online.
            </p>
          </div>
        </div>
        
        <div className="timeline-item">
          <div className="timeline-marker"><SynergysIcon variant="02" size={28} /></div>
          <div className="timeline-content">
            <div className="timeline-date">Q2 2026</div>
            <h4 className="timeline-title">Analytics com IA</h4>
            <p className="timeline-text">
              Análise de sentimento em respostas abertas. 
              Identificação de padrões — sem identificar pessoas.
            </p>
          </div>
        </div>
        
        <div className="timeline-item">
          <div className="timeline-marker"><SynergysIcon variant="03" size={28} /></div>
          <div className="timeline-content">
            <div className="timeline-date">Q3 2026</div>
            <h4 className="timeline-title">Integração ERP/RH</h4>
            <p className="timeline-text">
              Conectores para SAP, TOTVS, Senior. 
              Sincronização de estrutura sem dados pessoais.
            </p>
          </div>
        </div>
        
        <div className="timeline-item">
          <div className="timeline-marker"><SynergysIcon variant="01" size={28} /></div>
          <div className="timeline-content">
            <div className="timeline-date">Q4 2026</div>
            <h4 className="timeline-title">Certificação ISO 27001</h4>
            <p className="timeline-text">
              Certificação internacional de segurança. 
              Auditorias independentes regulares.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

function SlideContato() {
  return (
    <div className="slide contact-slide">
      <div className="contact-content">
        <img 
          src="/assets/logos/Synergys - Logotipo 01.png" 
          alt="Synergys" 
          className="contact-logo"
        />
        <h2 className="contact-title">Vamos Conversar?</h2>
        <p className="contact-text">
          Agende uma demonstração e veja como o anonimato funciona na prática
        </p>
        
        <div className="contact-info">
          <div className="contact-item">
            <SynergysIcon variant="01" size={24} />
            <span>contato@synergys.app.br</span>
          </div>
          <div className="contact-item">
            <SynergysIcon variant="02" size={24} />
            <span>(11) 4002-8922</span>
          </div>
          <div className="contact-item">
            <SynergysIcon variant="03" size={24} />
            <span>synergys.app.br</span>
          </div>
        </div>
        
        <button className="contact-btn">
          <SynergysIcon variant="01" size={24} />
          Agendar Demonstração
        </button>
      </div>
    </div>
  );
}

// Main App Component
function App() {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    SlideCover,
    SlideAnonimatoGarantido,
    SlideComoFunciona,
    SlideArquitetura,
    SlideSegurancaTecnica,
    SlidePerguntasFrequentes,
    SlideTiposPesquisa,
    SlideConformidade,
    SlideDashboard,
    SlidePrecos,
    SlideRoadmap,
    SlideContato
  ];
  
  const goToSlide = useCallback((index) => {
    if (index >= 0 && index < slides.length) {
      setCurrentSlide(index);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [slides.length]);
  
  const goNext = useCallback(() => {
    goToSlide(currentSlide + 1);
  }, [currentSlide, goToSlide]);
  
  const goPrev = useCallback(() => {
    goToSlide(currentSlide - 1);
  }, [currentSlide, goToSlide]);
  
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight' || e.key === ' ') {
        e.preventDefault();
        goNext();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goPrev();
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [goNext, goPrev]);
  
  const CurrentSlideComponent = slides[currentSlide];
  
  return (
    <div className="presentation">
      <CurrentSlideComponent />
      
      <nav className="nav-container">
        <button 
          className="nav-btn" 
          onClick={goPrev}
          disabled={currentSlide === 0}
        >
          <NavIcons.ChevronLeft />
          <span>Anterior</span>
        </button>
        
        <div className="pagination">
          <div className="pagination-dots">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`pagination-dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Ir para slide ${index + 1}`}
              />
            ))}
          </div>
          <span className="slide-counter">
            Slide {currentSlide + 1} de {slides.length}
          </span>
        </div>
        
        <button 
          className="nav-btn" 
          onClick={goNext}
          disabled={currentSlide === slides.length - 1}
        >
          <span>Próximo</span>
          <NavIcons.ChevronRight />
        </button>
      </nav>
    </div>
  );
}

export default App;
